import { getMainUrl } from 'containers/AppHeader/constants';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { getText } from 'services/languageService';
import { setOpenFeedbackModalAction } from 'store/actions/feedback';
import {
  setOpenLoginAction,
  setOpenLogoutAction,
} from 'store/actions/mainPage';
import { getCookie } from 'utils/cookie';
import { LeftMenuProps } from 'types/mainPage';
import { MainTitle } from 'containers/AppHeader/MainTitle';
import { ResponsiveElement } from 'components/UI/ResponsiveElements';
import { TooltipMapIcon } from 'components/UI/TooltipMapIcon';
import logo from 'images/main-logo.png';
import MenuIcon from '@mui/icons-material/Menu';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Link,
  Toolbar,
  Typography,
} from '@mui/material';

export const AppHeader: React.FC<LeftMenuProps> = ({ toggleDrawer }) => {
  const { lang } = useAppSelector((state) => state.mainPage);
  const dispatch = useAppDispatch();
  const user = getCookie('user') && JSON.parse(getCookie('user')!);

  const openLogInModal = () => {
    dispatch(setOpenLoginAction(true));
  };

  const openLogOutModal = () => {
    dispatch(setOpenLogoutAction(true));
  };

  return (
    <AppBar position="static">
      <Toolbar variant="dense" sx={{ display: 'flex' }}>
        <ResponsiveElement
          as={IconButton}
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{
            position: 'absolute',
            color: 'white',
          }}
          show={'mobile'}
        >
          <MenuIcon />
        </ResponsiveElement>

        <Link href="https://www.belstat.gov.by/">
          <TooltipMapIcon
            title={getText('MAIN_TITLE')}
            followCursor
            placement={'bottom'}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                '@media(max-width: 768px)': {
                  marginLeft: '50px',
                },
              }}
            >
              <img
                src={logo}
                alt="logo"
                style={{
                  width: '28px',
                }}
              />
            </Box>
          </TooltipMapIcon>
        </Link>

        <ResponsiveElement
          as={Link}
          sx={{
            color: 'white',
            '&:hover': {
              textDecoration: 'none',
            },
          }}
          show={'desktop'}
          href={getMainUrl(lang)}
        >
          <TooltipMapIcon
            title={getText('TO_MAIN')}
            followCursor
            placement={'bottom'}
          >
            <IconButton
              sx={{
                color: 'white',
              }}
            >
              <HomeRoundedIcon fontSize="large" />
            </IconButton>
          </TooltipMapIcon>
        </ResponsiveElement>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            justifyContent: 'center',
            pl: 5,

            '@media(max-width: 768px)': {
              pl: 0,
            },
          }}
        >
          <Box
            component="div"
            sx={{
              pl: 1,

              textAlign: 'center',
              '@media(max-width: 768px)': {
                maxWidth: 300,
              },
            }}
          >
            <MainTitle lang={lang} />
          </Box>
        </Box>

        <ResponsiveElement as={Box} show={'desktop'}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              variant="text"
              sx={{ color: 'white', mr: 2 }}
              onClick={() => {
                dispatch(setOpenFeedbackModalAction(true));
              }}
            >
              {getText('FEEDBACK')}
            </Button>
            {user && <Typography sx={{ mr: 2 }}>{user.login}</Typography>}

            {user ? (
              <Button
                variant="text"
                sx={{ color: 'white' }}
                onClick={openLogOutModal}
              >
                {getText('LOG_OUT')}
              </Button>
            ) : (
              <Button
                variant="text"
                sx={{ color: 'white' }}
                onClick={openLogInModal}
              >
                {getText('LOG_IN')}
              </Button>
            )}
          </Box>
        </ResponsiveElement>
      </Toolbar>
    </AppBar>
  );
};
